/* ═══════════════════════════════════════════════════════════════════════
   SOMA · tema Shopify
   Carrinho (AJAX do Shopify), escolha Filter / Espresso com imagem da
   variante, hero estilo Mezzo Mezzo, fita infinita, animações GSAP.
   Funciona também no editor do tema (secções recarregadas ao editar).
   ═══════════════════════════════════════════════════════════════════════ */
(() => {
const $ = (s, c = document) => c.querySelector(s), $$ = (s, c = document) => [...c.querySelectorAll(s)];
const S = window.SOMA || { routes:{ root:'/' }, text:{}, moneyFormat:'€{{amount_with_comma_separator}}' };
const QUIETO = matchMedia('(prefers-reduced-motion: reduce)').matches;
const TOQUE = matchMedia('(hover: none)').matches;
const temGSAP = () => !!window.gsap;
if (!temGSAP()) document.documentElement.classList.add('sem-anim');
const ICON = {
  sorriso:'<svg viewBox="0 0 100 100" fill="none" stroke="currentColor" stroke-width="7" stroke-linecap="round"><circle cx="50" cy="50" r="44"/><circle cx="36" cy="40" r="4" fill="currentColor" stroke="none"/><circle cx="64" cy="40" r="4" fill="currentColor" stroke="none"/><path d="M30 58c6 12 34 12 40 0"/></svg>',
  coracao:'<svg viewBox="0 0 100 100" fill="none" stroke="currentColor" stroke-width="12" stroke-linejoin="round"><path d="M12 34 50 86 88 34c-8-16-28-18-38-4-10-14-30-12-38 4z"/></svg>',
  grao:'<svg viewBox="0 0 60 80"><ellipse cx="30" cy="40" rx="24" ry="34" fill="#6b3a22"/><ellipse cx="24" cy="30" rx="8" ry="14" fill="#8a4e2f" opacity=".7"/><path d="M30 8c-10 14 10 26 0 64" stroke="#3e1f10" stroke-width="5" fill="none" stroke-linecap="round"/></svg>',
};

/* ═══ Dinheiro no formato da loja ═══ */
function money(cents) {
  const v = Number(cents) / 100, fmt = S.moneyFormat || '€{{amount_with_comma_separator}}';
  const n = (d, t, s) => { const [i, f] = v.toFixed(d).split('.'); return i.replace(/\B(?=(\d{3})+(?!\d))/g, t) + (d ? s + f : ''); };
  return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => ({
    amount:n(2, ',', '.'), amount_no_decimals:n(0, ',', '.'), amount_with_comma_separator:n(2, '.', ','),
    amount_no_decimals_with_comma_separator:n(0, '.', ','), amount_with_apostrophe_separator:n(2, "'", '.'),
  })[k] || n(2, ',', '.'));
}
const imgW = (url, w) => url ? url + (url.includes('?') ? '&' : '?') + 'width=' + w : '';

/* ═══ Saco de compras (carrinho do Shopify) ═══ */
const R = p => (S.routes.root || '/') + p;
async function lerCarrinho() { const r = await fetch(R('cart.js'), { headers:{ Accept:'application/json' } }); return r.json(); }
function desenhaCarrinho(c) {
  $$('.saco-btn .n').forEach(n => n.textContent = c.item_count);
  const lista = $('#itens'), rodape = $('#gaveta-rodape'), vazio = $('#vazio');
  if (!lista) return;
  if (!c.item_count) { lista.innerHTML = ''; vazio.hidden = false; rodape.hidden = true; return; }
  vazio.hidden = true; rodape.hidden = false;
  lista.innerHTML = c.items.map((i, k) => `<div class="item">
    <a class="mini" href="${i.url}" style="--fundo:var(--gelo)">${i.image ? `<img class="saco" src="${imgW(i.image, 200)}" alt="">` : ''}</a>
    <div><b>${i.product_title}</b><small>${[i.variant_title && i.variant_title !== 'Default Title' ? i.variant_title : '', i.properties && Object.keys(i.properties).some(k => k[0] !== '_' && i.properties[k]) ? Object.keys(i.properties).filter(k => k[0] !== '_' && i.properties[k]).map(k => i.properties[k]).join(' · ') : (i.selling_plan_allocation ? i.selling_plan_allocation.selling_plan.name : '')].filter(Boolean).join(' · ')}</small>
      <div class="qtd"><button data-linha="${k + 1}" data-q="${i.quantity - 1}" aria-label="−">−</button><span>${i.quantity}</span><button data-linha="${k + 1}" data-q="${i.quantity + 1}" aria-label="+">+</button></div></div>
    <div class="preco">${money(i.final_line_price)}</div></div>`).join('');
  $('#total').textContent = money(c.total_price);
}
async function mudaLinha(linha, q) {
  $('#gaveta')?.classList.add('a-carregar');
  const r = await fetch(R('cart/change.js'), { method:'POST', headers:{ 'Content-Type':'application/json', Accept:'application/json' }, body:JSON.stringify({ line:linha, quantity:Math.max(0, q) }) });
  desenhaCarrinho(await r.json()); $('#gaveta')?.classList.remove('a-carregar');
}
async function adiciona(id, q, origem, extra = {}) {
  if (!id) return;
  origem && (origem.disabled = true);
  const linha = { id:+id, quantity:+q || 1 };
  if (extra.plano) linha.selling_plan = +extra.plano;
  if (extra.props) linha.properties = extra.props;
  try {
    const r = await fetch(R('cart/add.js'), { method:'POST', headers:{ 'Content-Type':'application/json', Accept:'application/json' }, body:JSON.stringify({ items:[linha] }) });
    const j = await r.json();
    if (!r.ok) { avisa(j.description || j.message || 'Sorry, something went wrong'); return; }
    const item = (j.items || [])[0];
    const btn = $('#saco-btn');
    if (origem && btn) voa(origem, btn);
    setTimeout(() => { btn && (btn.classList.remove('pulo'), void btn.offsetWidth, btn.classList.add('pulo')); }, 600);
    avisa(extra.aviso || `${item ? item.product_title : ''} ${S.text.added || 'is in your bag'}`.trim());
    const novo = await lerCarrinho(); desenhaCarrinho(novo);
    document.dispatchEvent(new CustomEvent('soma:cart-updated', { detail:{ cart:novo } }));
  } finally { origem && (origem.disabled = false); }
}
function voa(de, para) {
  const zona = de.closest('[data-zona]'), fonte = zona && (zona.matches('#hero') ? $('#hero .slide.on img.saco') : $('img.saco', zona));
  const a = de.getBoundingClientRect(), b = para.getBoundingClientRect();
  const el = document.createElement('div'); el.className = 'voa';
  el.innerHTML = fonte ? `<img class="saco" src="${fonte.currentSrc || fonte.src}" alt="">` : ICON.coracao;
  el.style.left = (a.left + a.width / 2 - 40) + 'px'; el.style.top = (a.top + a.height / 2 - 40) + 'px';
  document.body.appendChild(el);
  const dx = b.left + b.width / 2 - (a.left + a.width / 2), dy = b.top + b.height / 2 - (a.top + a.height / 2);
  el.animate([
    { transform:'translate(0,0) scale(1) rotate(0)', opacity:1 },
    { transform:`translate(${dx * .5}px,${dy * .5 - 120}px) scale(.9) rotate(-20deg)`, opacity:1, offset:.5 },
    { transform:`translate(${dx}px,${dy}px) scale(.25) rotate(12deg)`, opacity:.2 },
  ], { duration:750, easing:'cubic-bezier(.5,0,.4,1)' }).onfinish = () => el.remove();
}
let tAviso;
function avisa(txt) {
  const a = $('#aviso'); if (!a) return;
  a.querySelector('span').textContent = txt;
  a.classList.add('on'); clearTimeout(tAviso); tAviso = setTimeout(() => a.classList.remove('on'), 2400);
}
const abreSaco = () => { $('#gaveta')?.classList.add('on'); $('#veu')?.classList.add('on'); document.body.classList.add('preso'); };
const fechaSaco = () => { $('#gaveta')?.classList.remove('on'); $('#veu')?.classList.remove('on'); document.body.classList.remove('preso'); };

/* ═══ Cliques globais: saco, escolha Filter / Espresso, quantidade ═══ */
document.addEventListener('click', e => {
  const t = e.target;
  if (t.closest('#saco-btn')) { abreSaco(); return; }
  if (t.closest('#fecha-saco') || t.closest('#veu')) { fechaSaco(); return; }
  const linha = t.closest('#itens button[data-linha]'); if (linha) { mudaLinha(+linha.dataset.linha, +linha.dataset.q); return; }
  const menu = t.closest('#menu-btn');
  if (menu) { const nav = $('#nav'); menu.setAttribute('aria-expanded', nav.classList.toggle('aberta')); return; }
  if (t.closest('#nav ul a')) $('#nav')?.classList.remove('aberta');

  const v = t.closest('[data-picker] [data-valor]');
  if (v) { escolheVariante(v); return; }

  const q = t.closest('[data-qtd]');
  if (q) {
    const el = $('#qtd-produto'), n = Math.max(1, +el.textContent + +q.dataset.qtd); el.textContent = n;
    $$('[data-qtd-input]').forEach(i => i.value = n);
    $$('.pagina-produto [data-add]').forEach(b => b.dataset.quantidade = n); return;
  }
  const add = t.closest('[data-add]');
  if (add && !add.disabled) { e.preventDefault(); adiciona(add.dataset.variant, add.dataset.quantidade || 1, add); }
});
addEventListener('keydown', e => { if (e.key === 'Escape') fechaSaco(); });
/* formulário de produto standard: sem recarregar a página (o Enter faz o mesmo que o botão) */
document.addEventListener('submit', e => {
  const f = e.target.closest('form[action*="/cart/add"]'); if (!f || !f.querySelector('[data-add]')) return;
  e.preventDefault(); f.querySelector('[data-add]').click();
});

function escolheVariante(b) {
  const picker = b.closest('[data-picker]'), grupo = b.closest('.torra'), zona = b.closest('[data-zona]') || document, pid = picker.dataset.produto;
  $$('button', grupo).forEach(o => { o.classList.toggle('on', o === b); o.setAttribute('aria-checked', o === b); });
  const escolha = $$('.torra', picker).map(g => ($('button.on', g) || $('button', g)).dataset.valor);
  let lista = []; try { lista = JSON.parse($('[data-variantes]', picker).textContent); } catch (e) {}
  const v = lista.find(x => x.opcoes.every((o, i) => o === escolha[i])) || lista.find(x => x.opcoes[+grupo.dataset.opcao] === b.dataset.valor);
  if (!v) return;
  $$(`[data-add][data-produto="${pid}"]`, zona).forEach(a => { a.dataset.variant = v.id; a.disabled = !v.disponivel; });
  $$('[data-variant-input]', zona).forEach(i => { i.value = v.id; i.dispatchEvent(new Event('change', { bubbles:true })); });
  if (v.img) $$(`img.saco[data-produto="${pid}"]`, zona).forEach(img => trocaImagem(img, v.img));
  $$(`[data-preco-produto="${pid}"], .preco-btn`, zona).forEach(p => p.textContent = v.preco);
  $$('[data-dica]', zona).forEach(d => d.hidden = d.dataset.dica !== escolha[0]);
  if (zona.matches && zona.matches('.pagina-produto')) { const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u); }
  zona.dispatchEvent(new CustomEvent('soma:variante', { detail:{ botao:b, variante:v } }));
  document.dispatchEvent(new CustomEvent('variant:change', { detail:{ variant:{ id:v.id, available:v.disponivel } } }));
}
function trocaImagem(img, src) {
  if (!src || img.getAttribute('src') === src) return;
  img.removeAttribute('srcset');
  if (!temGSAP() || QUIETO) { img.src = src; return; }
  img.src = src;
  gsap.fromTo(img, { scale:.92, rotation:-3 }, { scale:1, rotation:0, duration:.6, ease:'back.out(2.2)', overwrite:'auto' });
}

/* ═══ Barra do topo: transparente no topo, com fundo ao descer ═══ */
function navTopo() { const n = $('#nav'); if (n) n.classList.toggle('topo', scrollY < 24); }
addEventListener('scroll', navTopo, { passive:true });

/* ═══ Fita: scroll lateral infinito ═══ */
function iniciaFita(raiz = document) {
  $$('.fita', raiz).forEach(fita => {
    const trilho = $('.trilho', fita); if (!trilho || trilho.dataset.ok) return; trilho.dataset.ok = 1;
    const html = trilho.innerHTML, vel = (+fita.dataset.velocidade || 70) * (innerWidth < 760 ? .65 : 1);
    trilho.innerHTML = `<div class="bloco" style="display:inline-flex">${html}</div>`;
    const bloco = trilho.firstChild;
    let guarda = 0; while (bloco.scrollWidth < innerWidth * 1.2 && guarda++ < 20) bloco.insertAdjacentHTML('beforeend', html);
    trilho.appendChild(bloco.cloneNode(true));
    let x = 0, antes = performance.now();
    (function passo(agora) {
      if (!trilho.isConnected) return;
      const dt = Math.min(64, agora - antes); antes = agora;
      const w = bloco.getBoundingClientRect().width;
      x -= vel * dt / 1000; if (w && x <= -w) x += w;
      trilho.style.transform = `translate3d(${x}px,0,0)`;
      requestAnimationFrame(passo);
    })(antes);
  });
}

/* ═══ Revelações ao descer ═══ */
function revela(raiz = document) {
  if (!temGSAP() || QUIETO) { $$('.sobe', raiz).forEach(el => { el.style.opacity = 1; el.style.transform = 'none'; }); $$('.linhas .l > span', raiz).forEach(s => s.style.transform = 'none'); return; }
  gsap.registerPlugin(ScrollTrigger);
  $$('.linhas', raiz).forEach(t => gsap.to($$('.l > span', t), { y:0, duration:1.1, ease:'expo.out', stagger:.09, scrollTrigger:{ trigger:t, start:'top 85%' } }));
  if (matchMedia('(max-width:760px)').matches) $$('.manifesto .sobe', raiz).forEach(el => el.classList.remove('sobe'));
  $$('.sobe', raiz).forEach(el => gsap.to(el, { opacity:1, y:0, duration:1, ease:'expo.out', delay:+(el.dataset.d || 0), scrollTrigger:{ trigger:el, start:'top 92%' } }));
  $$('.fim h2', raiz).forEach(h => gsap.from(h, { y:80, opacity:0, duration:1.2, ease:'expo.out', scrollTrigger:{ trigger:h, start:'top 85%' } }));
  $$('.fim .flutua', raiz).forEach((f, i) => gsap.to(f, { y:-40 - i * 20, rotation:i ? 20 : -30, ease:'none', scrollTrigger:{ trigger:'.fim', scrub:true } }));
  const telemovel = matchMedia('(max-width:760px)').matches;
  $$('.grito', raiz).forEach(g => {
    // no telemóvel o texto já está lá; só as imagens aparecem com o scroll
    if (!telemovel) gsap.from(g, { y:60, opacity:0, duration:1.2, ease:'expo.out', scrollTrigger:{ trigger:g, start:'top 85%' } });
    gsap.to($$('.pilula', g), { scale:1, rotation:0, duration:1, ease:'back.out(2)', stagger:.2, scrollTrigger:{ trigger:g, start:'top 80%' } });
  });
}

/* ═══ Processo: a linha liga o 1 ao 4 e enche com o scroll ═══ */
function iniciaProcesso(raiz = document) {
  $$('[data-passos]', raiz).forEach(box => {
    const passos = $$('.passo', box), enche = $('.enche', box);
    if (!temGSAP() || QUIETO) { passos.forEach(p => p.classList.add('feito')); enche && (enche.style.transform = 'none'); return; }
    const vertical = matchMedia('(max-width:640px)').matches;
    gsap.to(enche, { [vertical ? 'scaleY' : 'scaleX']:1, ease:'none', scrollTrigger:{ trigger:box, start:vertical ? 'top 70%' : 'top 75%', end:vertical ? 'bottom 60%' : 'top 25%', scrub:.6 } });
    passos.forEach((p, i) => {
      gsap.from(p.querySelectorAll('.img, .txt'), { y:40, opacity:0, duration:1, ease:'expo.out', stagger:.08, scrollTrigger:{ trigger:p, start:'top 85%' } });
      ScrollTrigger.create({ trigger:vertical ? p : box, start:vertical ? 'top 62%' : `top ${75 - i * 16}%`, onEnter:() => p.classList.add('feito'), onLeaveBack:() => p.classList.remove('feito') });
    });
  });
}

/* ═══ How we brew it: um método de cada vez ═══ */
function iniciaMetodos(raiz = document) {
  $$('.metodo', raiz).forEach(sec => {
    const botoes = $$('[data-metodo]', sec), paineis = $$('[data-metodo-painel]', sec);
    botoes.forEach(b => b.addEventListener('click', () => {
      botoes.forEach(o => o.classList.toggle('on', o === b));
      paineis.forEach(p => {
        const on = p.dataset.metodoPainel === b.dataset.metodo; p.hidden = !on;
        if (on && temGSAP() && !QUIETO) {
          gsap.fromTo(p.querySelectorAll('.saco-sug, .porque, h3, p, .sug-torra, .btn'), { opacity:0, y:20 }, { opacity:1, y:0, duration:.6, stagger:.05, ease:'back.out(1.5)' });
          gsap.fromTo(p.querySelectorAll('.saco'), { rotation:-16, scale:.8 }, { rotation:0, scale:1, duration:.9, ease:'back.out(1.8)' });
        }
      });
    }));
  });
}

/* ═══ HERO: os cafés em montra (igual à Mezzo Mezzo) ═══ */
let heroAtual = null;
function iniciaHero(raiz = document, entrada = true) {
  const hero = $('#hero', raiz) || (raiz.id === 'hero' ? raiz : null);
  if (!hero) return null;
  const palco = $('.palco', hero), slides = $$('.slide', palco), torras = $$('.h-torra', hero);
  if (!slides.length) return null;
  const add = $('#h-add', hero), fantasma = $('#fantasma', hero);
  let ativo = 0, aMudar = false, pendente = 0, vivo = true;
  $('#pontos', hero).innerHTML = slides.map((_, i) => `<i${i ? '' : ' class="on"'}></i>`).join('');
  const pad = n => String(n).padStart(2, '0');
  function pinta(i) {
    const s = slides[i], d = s.dataset;
    if (d.fundo) hero.style.setProperty('--fundo', d.fundo);
    if (d.fantasma) hero.style.setProperty('--fantasma', d.fantasma);
    if (d.texto) hero.style.setProperty('--texto', d.texto);
    $('#h-cont', hero).textContent = `${pad(i + 1)} / ${pad(slides.length)}`;
    $('#h-nome', hero).textContent = d.nome;
    $('#h-notas', hero).textContent = d.notas;
    torras.forEach((t, k) => t.hidden = k !== i);
    const disponivel = d.disponivel === 'true';
    const atual = (heroVar[i] || { id:d.variant, preco:d.preco });
    add.dataset.produto = d.produto; add.dataset.variant = atual.id; add.disabled = !disponivel;
    add.innerHTML = disponivel ? `${add.dataset.rotulo} · <span data-preco-produto="${d.produto}">${atual.preco}</span>` : (S.text.soon || 'Soon in stock');
    $$('#pontos i', hero).forEach((p, k) => p.classList.toggle('on', k === i));
    fantasma.textContent = d.ghost;
  }
  const heroVar = {};
  add.dataset.rotulo = add.dataset.rotulo || add.textContent.trim();
  pinta(0);
  hero.addEventListener('soma:variante', e => { const k = torras.indexOf(e.detail.botao.closest('.h-torra')); if (k > -1) { heroVar[k] = e.detail.variante; if (k === ativo) pinta(ativo); } });

  function muda(dir, alvo) {
    if (slides.length < 2) return;
    if (aMudar) { pendente = Math.max(-3, Math.min(3, pendente + dir)); return; }
    aMudar = true;
    const velho = slides[ativo];
    ativo = alvo !== undefined ? alvo : (ativo + dir + slides.length) % slides.length;
    const novo = slides[ativo];
    if (!temGSAP()) { velho.classList.remove('on'); novo.classList.add('on'); pinta(ativo); aMudar = false; return; }
    gsap.to(velho.querySelector('.prod'), { xPercent:-dir * 190, rotation:-dir * 18, opacity:0, duration:.55, ease:'power3.in',
      onComplete:() => { velho.classList.remove('on'); gsap.set(velho.querySelector('.prod'), { clearProps:'all' }); } });
    novo.classList.add('on');
    gsap.fromTo(novo.querySelector('.prod'), { xPercent:dir * 190, rotation:dir * 22, opacity:0, scale:.85 },
      { xPercent:0, rotation:0, opacity:1, scale:1, duration:.9, delay:.35, ease:'back.out(1.3)', onComplete:() => { aMudar = false; if (pendente) { const d = Math.sign(pendente); pendente -= d; muda(d); } } });
    gsap.to(fantasma, { y:-30, opacity:0, duration:.3, ease:'power2.in' });
    const txt = ['#h-cont', '#h-nome', '#h-notas'].map(s => $(s, hero));
    gsap.to(txt, { y:-20, opacity:0, duration:.25, stagger:.04, ease:'power2.in', onComplete:() => {
      pinta(ativo);
      gsap.fromTo(txt, { y:24, opacity:0 }, { y:0, opacity:1, duration:.55, stagger:.06, ease:'back.out(1.6)' });
      gsap.fromTo(fantasma, { y:40, opacity:0 }, { y:0, opacity:1, duration:.8, ease:'power3.out' });
    }});
    implode();
  }
  $('#seg', hero).addEventListener('click', () => { pararAuto(); muda(1); });
  $('#ant', hero).addEventListener('click', () => { pararAuto(); muda(-1); });
  addEventListener('keydown', e => { if (!vivo || e.target.closest('input,textarea')) return; if (e.key === 'ArrowRight') muda(1); if (e.key === 'ArrowLeft') muda(-1); });
  let x0 = null, y0 = 0;
  hero.addEventListener('touchstart', e => { if (e.target.closest('button,a')) { x0 = null; return; } x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive:true });
  hero.addEventListener('touchend', e => {
    if (x0 === null) return;
    const dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0; x0 = null;
    if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.4) { pararAuto(); muda(dx < 0 ? 1 : -1); }
  }, { passive:true });
  if (!TOQUE) slides.forEach(s => s.addEventListener('click', () => { if (s.dataset.disponivel === 'true') location.href = s.dataset.url; }));
  const seg = +hero.dataset.autoplay;
  let auto = seg && !S.designMode ? setInterval(() => { if (!document.hidden && scrollY < innerHeight * .5) muda(1); }, seg * 1000) : 0;
  function pararAuto() { clearInterval(auto); auto = 0; }
  hero.addEventListener('pointerdown', pararAuto);

  /* grãos a flutuar, a fugir do rato */
  const GRAOS = [[7,30,62,-20],[16,72,48,30],[83,22,56,50],[90,60,70,-10],[72,82,44,80],[26,14,36,10],[60,10,30,-40],[40,86,34,120]];
  const caixa = $('#graos', hero); caixa.innerHTML = '';
  const graos = GRAOS.map(([x, y, t, r], i) => {
    const g = document.createElement('div'); g.className = 'grao';
    const k = innerWidth < 860 ? .6 : 1;
    Object.assign(g.style, { left:x + '%', top:y + '%', width:t * .75 * k + 'px', height:t * k + 'px' });
    g.innerHTML = ICON.grao; caixa.appendChild(g);
    return { el:g, rx:0, ry:0, a:r, i, o:{ x:0, y:0, s:1 } };
  });
  function implode() {
    if (!temGSAP()) return;
    const r = hero.getBoundingClientRect(), cx = r.width / 2, cy = r.height * .6;
    graos.forEach(g => {
      const b = g.el.getBoundingClientRect();
      gsap.timeline().to(g.o, { x:cx - (b.left + b.width / 2), y:cy - (b.top - r.top + b.height / 2), s:.1, duration:.45, ease:'power2.in' })
        .to(g.o, { x:0, y:0, s:1, duration:.9, delay:.15, ease:'back.out(1.7)', onStart:() => g.a += 90 });
    });
  }
  const rato = { x:-999, y:-999, nx:0, ny:0 }, suave = { x:0, y:0 };
  addEventListener('pointermove', e => { rato.x = e.clientX; rato.y = e.clientY; rato.nx = e.clientX / innerWidth - .5; rato.ny = e.clientY / innerHeight - .5; });
  (function quadro() {
    if (!vivo || !hero.isConnected) return;
    requestAnimationFrame(quadro);
    if (scrollY > innerHeight) return;
    const t = performance.now() / 1000, tx = TOQUE ? 0 : rato.nx, ty = TOQUE ? 0 : rato.ny;
    suave.x += (tx - suave.x) * .06; suave.y += (ty - suave.y) * .06;
    const g = slides[ativo].querySelector('.gira');
    if (!QUIETO && g) g.style.transform = `perspective(900px) rotateY(${suave.x * 22}deg) rotateX(${-suave.y * 10}deg) translateY(${Math.sin(t * 1.4) * 10}px) rotate(${Math.sin(t * .8) * 2}deg)`;
    graos.forEach(o => {
      const b = o.el.getBoundingClientRect(), dx = rato.x - (b.left + b.width / 2), dy = rato.y - (b.top + b.height / 2), d = Math.hypot(dx, dy) || 1;
      let mx = 0, my = 0, v = 1;
      if (!TOQUE && d < 260) { const f = (260 - d) / 260; mx = dx / d * f * -110; my = dy / d * f * -110; v = 1 + f * 5; }
      o.rx += (mx - o.rx) * .1; o.ry += (my - o.ry) * .1; o.a += .2 * v;
      const fy = Math.sin(t * (.6 + o.i * .07) + o.i) * 14;
      o.el.style.transform = `translate(${o.rx + o.o.x + suave.x * 30}px,${o.ry + o.o.y + fy + suave.y * 30}px) rotate(${o.a}deg) scale(${o.o.s})`;
    });
  })();

  function entra() {
    if (!temGSAP() || QUIETO) return;
    gsap.from(fantasma, { y:60, opacity:0, duration:1.1, ease:'power3.out', delay:.35 });
    gsap.from(slides[0], { y:innerHeight * .6, rotation:18, duration:1.3, ease:'back.out(1.15)', delay:.45 });
    gsap.from(graos.map(g => g.o), { s:0, duration:.9, ease:'back.out(2)', stagger:.05, delay:.7 });
    gsap.from([$('.tag', hero), ...$$('.info > *:not([hidden])', hero), $('.setas', hero), $('.selo', hero), $('#nav')].filter(Boolean), { y:30, opacity:0, duration:.9, ease:'expo.out', stagger:.06, delay:.6, clearProps:'transform' });
  }
  return { entra, vaiPara:i => { if (i !== ativo) muda(i > ativo ? 1 : -1, i); }, para:() => { vivo = false; pararAuto(); }, slides };
}

/* ═══ Abertura: o logotipo antes de entrar ═══ */
function abertura(depois) {
  const tpl = $('#intro-tpl');
  // a animação do logótipo só aparece na primeira vez que se abre o site (por sessão)
  let jaVista = false; try { jaVista = sessionStorage.getItem('soma-intro') === '1'; sessionStorage.setItem('soma-intro', '1'); } catch (e) {}
  if (!tpl || document.body.dataset.intro !== '1' || QUIETO || jaVista) { depois && depois(); return; }
  const el = document.createElement('div'); el.className = 'abertura';
  el.appendChild(tpl.content.cloneNode(true));
  document.body.appendChild(el); document.body.classList.add('preso');
  const img = $('img', el), txt = $('.linha-txt', el), cara = $('.cara', el), E = 'cubic-bezier(.16,1,.3,1)';
  img.animate([{ transform:'translateY(105%)' }, { transform:'none' }], { duration:1100, delay:200, easing:E, fill:'forwards' });
  cara.animate([{ opacity:0, transform:'scale(.4) rotate(-30deg)' }, { opacity:1, transform:'scale(1) rotate(0)' }], { duration:900, delay:850, easing:'cubic-bezier(.34,1.56,.64,1)', fill:'forwards' });
  txt.animate([{ opacity:0, transform:'translateY(14px)' }, { opacity:1, transform:'none' }], { duration:1000, delay:1000, easing:E, fill:'forwards' });
  setTimeout(() => {
    el.classList.add('fim');
    el.animate([{ clipPath:'circle(150% at 50% 50%)' }, { clipPath:'circle(0% at 50% 50%)' }], { duration:1100, easing:'cubic-bezier(.76,0,.24,1)', fill:'forwards' }).onfinish = () => el.remove();
    document.body.classList.remove('preso');
    depois && depois();
  }, 2300);
}

/* ═══ Subscrição roaster choice: só se escolhe quantos sacos por mês ═══ */
function iniciaSubs(raiz = document) {
  $$('[data-subs]', raiz).forEach(sec => {
    if (sec.dataset.pronto) return; sec.dataset.pronto = '1';
    let D = null, T = {};
    try { D = JSON.parse($('[data-subs-dados]', sec).textContent); T = JSON.parse($('[data-subs-textos]', sec).textContent); } catch (e) {}
    const caixa = $('[data-subs-caixa]', sec), btn = $('[data-subs-add]', sec);
    if (!D || !D.planos.length || !D.variantes.length) {
      $$('.passo, .subs-fim, .subs-nota', caixa).forEach(el => el.hidden = true);
      $('[data-subs-vazio]', sec).hidden = false; return;
    }
    const esc = v => String(v).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');
    const num = s => { const m = String(s).match(/\d+/); return m ? +m[0] : 0; };
    // plano mensal (o primeiro que entrega todos os meses; senão o primeiro)
    const plano = D.planos.find(p => /every month|every 1 month/i.test(p.nome)) || D.planos[0];
    const vars = D.variantes.filter(v => plano.id in v.planos).sort((a, b) => num(a.nome) - num(b.nome));
    if (!vars.length) { $$('.passo, .subs-fim, .subs-nota', caixa).forEach(el => el.hidden = true); $('[data-subs-vazio]', sec).hidden = false; return; }
    // 1000 g → 1 kg
    vars.forEach(v => { const m = String(v.peso).match(/^([\d.,]+)\s*g$/i); if (m && parseFloat(m[1]) >= 1000) v.peso = (parseFloat(m[1]) / 1000).toString().replace('.', ',') + ' kg'; });
    const st = { v:vars.find(v => v.disponivel) || vars[0] };
    const preco = v => v.planos[plano.id] ?? v.preco;
    const fill = (txt, v) => String(txt).replace('[bags]', v.nome).replace('[weight]', v.peso || '').replace(/\s*\(\)\s*/, ' ').replace(/·\s*·/g, '·').trim();

    function desenha() {
      $('[data-subs-grupo="sacos"]', sec).innerHTML = vars.map(v => `<button type="button" data-valor="${v.id}" class="${v === st.v ? 'on' : ''}"${v.disponivel ? '' : ' disabled'}><b>${esc(v.nome)}</b>${v.peso ? `<small>${esc(v.peso)}</small>` : ''}<span>${money(preco(v))}</span></button>`).join('');
      $('[data-subs-total]', sec).textContent = money(preco(st.v));
      $('[data-subs-conta]', sec).textContent = fill(T.breakdown || '[bags] · [weight] of coffee every month', st.v);
      btn.disabled = !st.v.disponivel;
    }
    desenha();

    sec.addEventListener('click', e => {
      const b = e.target.closest('[data-subs-grupo="sacos"] button[data-valor]'); if (!b || b.disabled) return;
      st.v = vars.find(x => x.id === +b.dataset.valor) || st.v; desenha();
    });
    btn.addEventListener('click', () => {
      if (!st.v.disponivel) return;
      const props = { [T.property_label || 'Subscription']: fill(T.property_value || 'Roaster choice · [bags] ([weight]) · Renews every month, cancel anytime', st.v) };
      adiciona(st.v.id, 1, btn, { plano:plano.id, aviso:T.added, props });
    });
  });
}

/* ═══ Secções opcionais: contagem decrescente e aviso com mensagens alternadas ═══ */
function iniciaExtras(raiz = document) {
  $$('[data-contagem]', raiz).forEach(sec => {
    if (sec.dataset.pronto) return; sec.dataset.pronto = '1';
    const txt = (sec.dataset.fim || '').trim().replace(' ', 'T');
    const fim = txt ? new Date(txt) : null;
    const rel = $('[data-relogio]', sec), acabou = $('[data-acabou]', sec);
    if (!fim || isNaN(fim)) { rel.hidden = true; return; }
    const dois = n => String(n).padStart(2, '0');
    const passo = () => {
      if (!sec.isConnected) return clearInterval(id);
      let s = Math.max(0, Math.floor((fim - Date.now()) / 1000));
      if (!s) {
        clearInterval(id); rel.hidden = true; acabou.hidden = false;
        if (sec.dataset.esconde === 'true' && !(S.designMode)) sec.closest('.shopify-section')?.setAttribute('hidden', '');
        return;
      }
      const d = Math.floor(s / 86400); s %= 86400; const h = Math.floor(s / 3600); s %= 3600; const m = Math.floor(s / 60); s %= 60;
      $('[data-u="d"]', sec).textContent = dois(d); $('[data-u="h"]', sec).textContent = dois(h);
      $('[data-u="m"]', sec).textContent = dois(m); $('[data-u="s"]', sec).textContent = dois(s);
    };
    const id = setInterval(passo, 1000); passo();
  });
  $$('.anuncio-fixo', raiz).forEach(b => {
    const ps = $$('p', b); if (ps.length < 2 || b.dataset.pronto) return; b.dataset.pronto = '1';
    let i = 0; setInterval(() => { if (!b.isConnected) return; ps[i].hidden = true; i = (i + 1) % ps.length; ps[i].hidden = false; }, 4000);
  });
}

/* ═══ Arranque ═══ */
function inicia(raiz = document) {
  iniciaFita(raiz); iniciaMetodos(raiz); revela(raiz); iniciaProcesso(raiz); iniciaSubs(raiz); iniciaExtras(raiz);
}
navTopo();
lerCarrinho().then(desenhaCarrinho).catch(() => {});
/* apps que mexem no carrinho (upsells, bundles) podem pedir para o saco atualizar */
const refrescaSaco = () => lerCarrinho().then(desenhaCarrinho).catch(() => {});
['cart:refresh', 'cart:updated', 'cart:change'].forEach(n => document.addEventListener(n, refrescaSaco));
addEventListener('pageshow', e => { if (e.persisted) refrescaSaco(); });
S.refreshCart = refrescaSaco; S.openCart = () => abreSaco();
window.SOMA = S;
heroAtual = iniciaHero(document);
inicia(document);
abertura(() => heroAtual && heroAtual.entra());

/* editor do tema: volta a ligar tudo quando uma secção muda */
document.addEventListener('shopify:section:load', e => {
  if ($('#hero', e.target)) { heroAtual && heroAtual.para(); heroAtual = iniciaHero(e.target); }
  inicia(e.target);
  if (window.ScrollTrigger) ScrollTrigger.refresh();
});
document.addEventListener('shopify:block:select', e => {
  if (!heroAtual) return;
  const i = heroAtual.slides.indexOf(e.target.closest('.slide') || e.target);
  if (i > -1) heroAtual.vaiPara(i);
});
})();
